var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.navigationItems)?_c('nav',[_c('ul',_vm._l((_vm.navigationItems),function(item,i){return _c('navigation-tree-item',{key:i,attrs:{"item":item}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }